
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { Subject } from 'rxjs';
import { TablepageBaseComponent } from '../../abstract/tablepage-base/tablepage-base.component';
import { ServiceDialogComponent } from '../../dialogs/service-dialog/service-dialog.component';
import { Service } from '../../models/service';
import { ApiService } from '../../services/api.service';
import { UiNotificationService } from '../../services/ui-notification.service';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-services',
  imports: [
    FormsModule,
    ButtonModule,
    TableModule,
    InputTextModule,
    TablepageBaseComponent,
    ServiceDialogComponent,
    TranslatePipe
],
  standalone: true,
  templateUrl: './services.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class ServicesComponent implements OnInit, OnDestroy {
  messageService = inject(UiNotificationService);

  loading: boolean = false;
  showDialog: boolean = false;
  dtTrigger: Subject<boolean> = new Subject<boolean>();

  services: Service[] = [];
  selectedService: Service = Reset.service();

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  onServiceSaved(service: Service) {
    this.selectedService = Reset.service();
    this.loadData();
  }

  onShowDialog(service: Service): void {
    this.selectedService = { ...service }
    this.showDialog = true;
  }

  private loadData(): void {
    this.loading = true;

    this.apiService.getServices().subscribe({
      next: (data) => {
        this.services = data.sort((a, b) => a.serviceId - b.serviceId);
        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.messageService.showError(err);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}
